<template>
    <div class="modal-card" style="width: auto; max-width: 500px; min-width: 400px;">
        <header class="modal-card-head">
            <p class="modal-card-title" style="margin: 0px;">Invitations</p>
        </header>
        <section class="modal-card-body change-password-modal">
            <div class="permissions-container">
                <div class="permission-person" v-for="(member, index) in workspace.invitations" :key="'member' + index">
                    <div class="profile-picture">
                        <i class="fas fa-user"></i>
                    </div>
                    <span class="name-and-email-address">
                        <i>{{member.email}}</i>
                    </span>
                    <b-button type="is-danger" size="is-small" v-if="memberJoined(member)" @click="removeMember(member)">Remove</b-button>
                    <b-button type="is-warning" size="is-small" v-else @click="cancelInvitation(member.id)">Cancel invitation</b-button>
                </div>
            </div>
            <div class="invite-form">
                <div class="col-xs-9" style="padding: 0px">
                    <b-field>
                        <b-input type="email" ref="email" placeholder="New email" v-model="inviting_email" required></b-input>
                    </b-field>
                </div>
                <div class="col-xs-3" style="padding: 0px">
                    <b-button type="is-primary" v-if="!inviting" @click="inviteUser()"><i class="fas fa-users"></i> Invite</b-button>
                    <b-button type="is-primary" v-else loading> Invite</b-button>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot" style="text-align: right;">
            <button class="button" type="button" @click="$parent.close()">Close</button>
        </footer>
    </div>
</template>

<script>
import {removeMemberFromWorkspace} from '../logic/workspace'
let inviting = false;
let inviting_email = "";

export default {
    name: 'ModalInviteUser',
    props: {
        workspace: Object,
    },
    data(){
        return {
            inviting: inviting,
            inviting_email: inviting_email
        }
    },
    components: {},
    methods:{
        removeMember: function(member){
            let member_id = null
            for(let i = 0; i < this.workspace.members.length; i++){
                if(this.workspace.members[i]["email"] == member.email){
                    member_id = this.workspace.members[i]["id"]
                }
            }
            removeMemberFromWorkspace(this.workspace.id, member_id).then(response => {
                this.$emit('member_deleted', response);
                this.$parent.close();
            }).catch(error => {
                console.log(error)
            })
        },
        memberJoined: function(member){
            let email = member.email
            let joined = false
            for(let i = 0; i < this.workspace.members.length; i++){
                console.log(this.workspace.members[i])
                if(this.workspace.members[i]["email"] == email){
                    joined = true
                }
            }
            return joined
        },
        cancelInvitation: function(invitation_id){
            this.$emit('cancel_invitation', invitation_id);
            this.$parent.close();
        },
        inviteUser: function(){
            this.inviting = true;
            let _this = this
            let isValid = this.$refs.email.checkHtml5Validity()
            if(isValid){
                this.$emit('created_invitation', this.inviting_email);
                this.$parent.close();

                setTimeout(function(){
                    _this.inviting = false;
                }, 500)
            }else{
                this.inviting = false;
            }
        },
        emitEvent: function(){
            this.$emit('task_created', this.task);
            this.$parent.close();
        },
    },
}
</script>

<style scoped>
    .permissions-container{
        max-height: 350px;
        overflow-y: auto;
    }
    .permission-person{
        clear: both;
        overflow: hidden;
        margin-bottom: 15px;
        font-size: 12px;
    }
    .permission-person >>> .button{
        margin-left: 75px;
        float: right;
    }
    .permission-person .profile-picture{
        background: #63b7e5;
        float: left;
        height: 30px;
        width: 30px;
        border-radius: 100%;
        text-align: center;
        line-height: 30px;
        margin-right: 10px;
    }
    .permission-person .name-and-email-address{
        float: left;
        margin-top: 5px;
    }
    .permission-person .name-and-email-address i{
        display: block;
    }
    .invite-form i{
        margin-right: 3px;
    }
    .invite-form >>> .field,
    .invite-form >>> .button{
        width: 100%;
        border-radius: 0px
    }
    .invite-form >>> .field input{
        border-radius: 0px
    }
    .invite-form{
        margin-top: 20px;
        border-top: 1px solid #ccc;
        padding-top: 20px;
    }
</style>
